<section>
	@if (companyContacts().length === 0) {
		{{ 'company.missing-contact' | translate }}
	}
	@for (contact of companyContacts(); track contact.id) {
		<editable-content #contactEditor *editableData="let edit from contact" [clickToEdit]="false" (valueChanged)="updateContact(contact.id!, $event)">
			<display-content>
				<section one-column [attr.alert]="contactIsValid(contact) ? null : ''">
					<icon type="circle-user" [badge]="contactSymbols(contact)" bottom center />
					<menu>
						@if (enableEdit) {
						<menuitem (click)="contactEditor.beginEdit();"><icon type="user-edit" />{{ 'contact.edit' | translate }}</menuitem> }
						@if (enableDelete && contact.id != company.primaryContactId && contact.id != company.billingContactId) {
						<menuitem (click)="deleteContact(contact)"><icon type="user-slash" />{{ 'contact.delete' | translate }}</menuitem>
						}
					</menu>
					<text-group>
						@if (!contactIsValid(contact)) { <div>{{ 'company.missing-contact-information' | translate }}</div> }
						@if (contact.fullName && contact.fullName.length > 0) { <h3>{{ contact.fullName }}</h3> }
						@if (contact.role && contact.role.length > 0) { <div>{{ contact.role }}</div> }
						@for (contactPhone of contact.contactPhones; track contactPhone.id) {
							<div>
								@if (contactPhone.number && contactPhone.number.length > 0) {
									<button small href="tel:{{ contactPhone.number }}">
										<icon type="phone" />
										{{ contactPhone.number }}
									</button>
								}
							</div>
						}
						<div>
							@if (contact.emailAddress && contact.emailAddress.length > 0) {
							<button small href="mailto:{{ contact.emailAddress }}">
								<icon type="envelope" />
								{{ contact.emailAddress }}
							</button>
							}
						</div>
					</text-group>
				</section>
			</display-content>
			<edit-content>
				@if (edit.value) {
					<contact [(primaryContactId)]="primaryContactId" [(billingContactId)]="billingContactId" [contact]="edit.value" />
				}
			</edit-content>
		</editable-content>
	}
	@if (newContact) {
		<editable-content #editNew [clickToEdit]="false" *editableData="let edit from newContact" (valueChanged)="createContact($event)">
			<edit-content>
				@if (edit.value) {
					<contact [(primaryContactId)]="primaryContactId" [contact]="edit.value" />
				}
			</edit-content>
		</editable-content>
	}
</section>
